<!-- For Desktop Screens -->
@if (screenWidth() > 600) {
<div
  class="min-h-screen  flex items-center justify-center bg-[url('/assets/images/bg-img.jpg')] bg-no-repeat bg-center bg-cover space-y-6 py-10">
  <div class="relative w-full max-w-md h-[650px] rounded-2xl bg-white flex items-center justify-center">
    <div class="flex flex-col items-center text-center px-5 space-y-4">
      <img src="assets/SVG/under_maintenance.svg" />
      <p class="text-md font-semibold">{{'common.UNDER_MAINTENANCE' | translate}}</p>
      <p class="text-sm">
        {{'common.UNDER_MAINTENANCE_TEXT' | translate}}
      </p>
    </div>
  </div>
</div>
}

<!-- For Mobile Screens -->
@else {
  <div class="relative w-full max-w-[600px] h-[800px] bg-white flex items-center justify-center">
    <div class="flex flex-col items-center text-center px-5 space-y-4">
      <img src="assets/SVG/under_maintenance.svg" />
      <p class="text-md font-semibold">{{'common.UNDER_MAINTENANCE' | translate }}</p>
      <p class="text-sm">
        {{'common.UNDER_MAINTENANCE_TEXT' | translate  }}
      </p>
    </div>
  </div>
}